const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        sessionStatus: {},
        renew: { count: 0, status: 'OK' },
        errorInResponse: false,
    });
};

const initialState = setInitialState();

const sessionReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.CHANGE_TIME_LEFT:
            const time = action.data.expiresIn;
            const expired = action.data.expired;
            const closed = action.data.closedByNewLogin;
            let renew = state.get('renew');
            const renewals = renew.get('count');
            const min = Math.floor(time / 60);
            const sec = time - min * 60;
            const sessionStatus = {
                minLeft: min,
                secLeft: sec,
                status: action.data.status,
                renewals: renewals,
                expired: expired,
                closed: closed,
            };

            return state.merge({
                sessionStatus,
            });

        case actionTypes.RENEW_STATUS:
            renew = state.get('renew');
            const count = renew.get('count');

            renew = {
                count: count + 1,
                status: action.data.status,
            };

            return state.merge({
                renew,
            });

        case actionTypes.ERROR_IN_RESPONSE:
            return state.merge({
                sessionStatus: {
                    errorInResponse: true,
                },
            });
        case actionTypes.CLOSED_BY_NEW_LOGIN:
            return state.merge({
                sessionStatus: {
                    closed: true,
                },
            });

        default:
            return state;
    }
};

module.exports = sessionReducer;
